// extracted by mini-css-extract-plugin
module.exports = {"mobileView":"ContentPage_mobileView__GJNj6","imageBox":"ContentPage_imageBox__aBRMg","theoryPageTopContent":"ContentPage_theoryPageTopContent__RU6GL"};